import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { Dashboard } from './pages/Dashboard';
import { Listings } from './pages/Listings';
import { DraftStudio } from './pages/DraftStudio';
import { ImageLab } from './pages/ImageLab';
import { Content } from './pages/Content';
import { Orders } from './pages/Orders';
import { Analytics } from './pages/Analytics';
import { Settings } from './pages/Settings';
import { StudioLogin } from './pages/StudioLogin';
import { StudioAuth } from './api/client';
import { useStore } from './store';

export default function App() {
  const refreshAuth = useStore((s) => s.refreshAuth);
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    StudioAuth.session()
      .then((session) => setAuthenticated(session.authenticated))
      .catch(() => setAuthenticated(false));
  }, []);

  useEffect(() => {
    if (authenticated) refreshAuth();
  }, [authenticated, refreshAuth]);

  if (authenticated === null) return <main className="studio-auth-loading" />;
  if (!authenticated) return <StudioLogin onLoggedIn={() => setAuthenticated(true)} />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/draft-studio" element={<DraftStudio />} />
        <Route path="/draft-studio/:id" element={<DraftStudio />} />
        <Route path="/image-lab" element={<ImageLab />} />
        <Route path="/content" element={<Content />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
